import React from 'react';
import '../App.css';

const logos = [
  { src: './clients/bdkq.png', name: 'bdkq' },
  { src: './clients/hpl.png', name: 'hpl' },
  { src: './clients/hnfy.png', name: 'hnfy' },
  { src: './clients/bz.jpeg', name: 'bz' },
  { src: './clients/bdrm.png', name: 'bdrm' },
  { src: './clients/dz.jpeg', name: 'dz' },
  { src: './clients/mjn.jpg', name: 'mjn' },
  { src: './clients/jt.png', name: 'jt' },
  { src: './clients/tr.png', name: 'tr' },
//  { src: './clients/tyyy.jpg', name: 'tyyy' },
  { src: './clients/hx.png', name: 'hx' },
];

function ClientsTestimonials() {
  return (
    <section id="cases">
      <h2>部分案例</h2>
      <div className="logo-grid">
        {logos.map((logo, i) => (
          <div className="logo-card" key={i}>
            <img src={logo.src} alt={logo.name} className="client-logo" loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  );
}
export default ClientsTestimonials; 